import { SVGProps } from "react";

const GreenCheckCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width || 20}
    height={props.height || 20}
    viewBox="0 0 20 20"
    fill="none"
    {...props}
  >
    <path
      fill="#45A159"
      d="M10.002 1.04A8.959 8.959 0 1 1 10 18.956a8.959 8.959 0 0 1 .002-17.918m4.064 5.642a.834.834 0 0 0-1.13-.332c-1.524.833-2.785 2.442-3.632 3.739-.313.48-.58.934-.794 1.318a8.27 8.27 0 0 0-1.166-.929l-.263-.163a.834.834 0 0 0-.826 1.449l.176.109c.119.078.285.194.47.34.382.301.793.697 1.052 1.13a.835.835 0 0 0 1.474-.082l.08-.171A20.527 20.527 0 0 1 10.699 11c.82-1.255 1.895-2.563 3.037-3.187a.834.834 0 0 0 .331-1.131"
    />
  </svg>
);

export default GreenCheckCircle;
